// extracted by mini-css-extract-plugin
export default {"pageWrapper":"service-request-page_pageWrapper__MYIKH","tabsBar":"service-request-page_tabsBar__W4gsy","tabContent":"service-request-page_tabContent__f5qBI"};